import React, { useEffect, useState } from 'react';
import { Button } from '@gerdau/hefesto';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  BottomButtons,
  BottomContainer,
  BottomSummary,
  ItensQuantity
} from './styles';
import { ApplicationState } from '../../../../../store';
import { EPurchaseRoutes } from '../../../purchase.routes';
import { EOrderSettingsRoutes } from '../../OrderSettingsMvp/orderSettings.routes';
import { ERoutes } from '../../../../../routes';

export const ProductBottomBar = ({
  loading,
  littleContent
}: {
  loading?: boolean;
  littleContent?: boolean;
}) => {
  const cartQuantity = useSelector(
    (state: ApplicationState) => state.cartItemsMvp?.quantity || 0
  );
  const [isLittle, setIsLittle] = useState(false);

  useEffect(() => {
    const validate = () => {
      if (littleContent !== undefined) {
        setIsLittle(littleContent);
      }
    };

    validate();
  }, [littleContent]);

  const products = cartQuantity;
  const productAmount =
    products > 1 ? 'produtos adicionados' : 'produto adicionado';
  const { emitterId } = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const { goBack, push } = useHistory();

  const handleGoBack = () => {
    goBack();
  };

  const handleGo = () => {
    const url = `${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}/${EPurchaseRoutes.COMMERCE}/${EOrderSettingsRoutes.SHOPPING_CART}`;
    push(`${url}`);
  };

  return (
    <BottomContainer littleContent={isLittle}>
      <BottomSummary>
        <ItensQuantity>
          {products
            ? `${products} ${productAmount}`
            : 'Nenhum produto adicionado'}
        </ItensQuantity>
      </BottomSummary>

      <BottomButtons>
        <Button
          name={'go-back-button'}
          variant="secondary"
          onClick={handleGoBack}
          disabled={loading}
        >
          Voltar
        </Button>
        <Button
          name={'go-to-shopping-cart-button'}
          onClick={handleGo}
          disabled={!emitterId || products === 0 || loading}
        >
          Avançar para o carrinho
        </Button>
      </BottomButtons>
    </BottomContainer>
  );
};
